import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminUserEditHeader = ({
  profile,
  isSelfEdit,
}) => {
  const intl = useIntl();

  const getTitle = () => {
    if (!profile.uuid) {
      return intl.formatMessage({ defaultMessage: 'New User' });
    }

    if (isSelfEdit) {
      return intl.formatMessage({ defaultMessage: 'Edit Profile' });
    }

    return intl.formatMessage({ defaultMessage: 'Edit User' });
  };

  return (
    <header className="page-header">
      <h3>
        {getTitle()}
      </h3>
    </header>
  );
};

AdminUserEditHeader.propTypes = {
  profile: PropTypes.object,
  isSelfEdit: PropTypes.bool.isRequired,
};

AdminUserEditHeader.defaultProps = {
  profile: null,
};

export default AdminUserEditHeader;
